!function(a,b){function d(a){var e,c=b.createElement("iframe"),d="https://open.weixin.qq.com/connect/qrconnect?appid="+a.appid+"&scope="+a.scope+"&redirect_uri="+a.redirect_uri+"&state="+a.state+"&login_type=jssdk";d+=a.style?"&style="+a.style:"",d+=a.href?"&href="+a.href:"",c.src=d,c.frameBorder="0",c.allowTransparency="true",c.scrolling="no",c.sandbox='allow-top-navigation allow-forms allow-scripts allow-same-origin', c.width="300px",c.height="400px",e=b.getElementById(a.id),e.innerHTML="",e.appendChild(c)}a.WxLogin=d}(window,document);


//////////////////
// WEBPACK FOOTER
// /Users/mac/001.code/xbigger-web/xbigger/fnjinew/view-v2/vendor/weixin/wxLogin.js
// module id = 39
// module chunks = 0 1 2 3 4 5 6